import { apiRequest, invalidateCache } from './apiConfig';

export const createLead = async (leadData) => {
  const response = await apiRequest('leads', {
    method: 'POST',
    body: leadData
  }, false); // Don't cache POST requests
  
  // Invalidate leads cache after creating a new lead
  invalidateCache('leads');
  return response;
};

export const getLeads = async (forQuotation = false) => {
  const endpoint = forQuotation ? 'leads?forQuotation=true' : 'leads';
  return await apiRequest(endpoint);
};

export const getLead = async (id) => {
  return await apiRequest(`leads/${id}`);
};

export const updateLead = async (id, leadData) => {
  const response = await apiRequest(`leads/${id}`, {
    method: 'PUT',
    body: leadData
  }, false); // Don't cache PUT requests
  
  // Invalidate leads cache after updating
  invalidateCache('leads');
  return response;
};

export const deleteLead = async (id) => {
  const response = await apiRequest(`leads/${id}`, {
    method: 'DELETE'
  }, false); // Don't cache DELETE requests
  
  // Invalidate leads cache after deletion
  invalidateCache('leads');
  return response;
};

export const checkEmailExists = async (email, excludeId = null) => {
  return await apiRequest('leads/check-email', {
    method: 'POST',
    body: { email, excludeId }
  }, false); // Don't cache email checks
};

export const checkPhoneExists = async (phone, excludeId = null) => {
  return await apiRequest('leads/check-phone', {
    method: 'POST',
    body: { phone, excludeId }
  }, false); // Don't cache phone checks
};

export const checkWhatsappExists = async (whatsapp, excludeId = null) => {
  return await apiRequest('leads/check-whatsapp', {
    method: 'POST',
    body: { whatsapp, excludeId }
  }, false); // Don't cache WhatsApp checks
};

/**
 * Export leads data
 * @param {Object} params - { startDate, endDate }
 * @returns {Promise<Object>} - Response with leads data for export
 */
export const exportLeads = async (params = {}) => {
  try {
    const query = new URLSearchParams(params).toString();
    const endpoint = `leads/export?${query}`;
    // Use apiRequest and specify no caching for this request
    const response = await apiRequest(endpoint, { method: 'GET' }, false);
    return response;
  } catch (error) {
    console.error('Error exporting leads:', error);
    throw error;
  }
}; 